/** Combined US ZIP and Canadian postal code pattern (NANP markets). */
const nanpPostalCodePattern =
  /^(\d{5}-\d{4}|\d{5}|\d{9})$|^([a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d)$/;

export { nanpPostalCodePattern };
